var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',{staticClass:"temp-logo",attrs:{"src":require("@/assets/images/illustrations/line_claw.svg")}})}
var staticRenderFns = []

export { render, staticRenderFns }